import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Headers, Http, RequestOptions, Response, URLSearchParams } from '@angular/http';
import { finalize, map } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { AuthenticationService } from '@app/core/authentication/authentication.service';

@Injectable()
export class BettingService {
  public total: number = null;
  public _fixtures: any | null = [];
  private _fixturesSubject: Subject<any | null> = new BehaviorSubject([]);
  fixtures$: Observable<any | null> = this._fixturesSubject.asObservable();
  public _history: any | null = [];
  private _historySubject: Subject<any | null> = new BehaviorSubject([]);
  history$: Observable<any | null> = this._historySubject.asObservable();

  constructor(private http: Http, private auth: AuthenticationService) {
    this.auth.userInfo$.subscribe(data => {
      if (data) {
        this.history();
      } else {
        this._history = [];
        this._historySubject.next(this._history);
      }
    });
  }

  list(params: { page: number; sport: string; game?: string } = { page: 0, sport: 'esports', game: null }) {
    let extraParams = '';
    if (params.game) {
      extraParams += `&game=${params.game}`;
    }
    return this.http
      .get(
        `https://${environment.mutualBettingServer}/fixtures?sport=${params.sport}&page=${params.page}${extraParams}`
      )
      .toPromise()
      .then((data: any) => {
        this.total = data.json().total;
        this._fixtures = data.json().fixtures;
        this._fixturesSubject.next(this._fixtures);
        return data.json();
      })
      .catch(e => {
        this.total = 0;
        this._fixtures = [];
        this._fixturesSubject.next(this._fixtures);
      });
  }

  listByIds(ids: Array<string> = []) {
    return this.http.get(`https://${environment.mutualBettingServer}/fixtures-by-ids?ids=${ids}`).pipe(
      map((response: Response) => {
        return response.json();
      })
    );
  }

  bet(data: { amount: number; fixtureId: string; betType: string }) {
    const headers = new Headers();
    headers.append('Authorization', this.auth.credentials.accessToken);

    return this.http.post(`https://${environment.mutualBettingServer}/betting/bet`, data, { headers }).pipe(
      map((response: Response) => {
        return response.json();
      })
    );
  }
  fixtureSettings(fixtureId: string) {
    const headers = new Headers();
    headers.append('Authorization', this.auth.credentials.accessToken);

    return this.http.get(`https://${environment.mutualBettingServer}/fixtures/${fixtureId}`, { headers }).pipe(
      map((response: Response) => {
        return response.json();
      })
    );
  }
  history(params: { page: number; sport: string; game?: string } = { page: 0, sport: 'esports', game: null }) {
    const headers = new Headers();
    headers.append('Authorization', this.auth.credentials.accessToken);

    return this.http
      .get(`https://${environment.mutualBettingServer}/betting/history?sport=${params.sport}&page=${params.page}`, {
        headers,
      })
      .toPromise()
      .then((data: any) => {
        this._history = data.json().data;
        this._historySubject.next(this._history);
        return data.json();
      })
      .catch(e => {
        this._history = [];
        this._historySubject.next(this._history);
      });
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/core/betting.service.ts